import { JsonSchemaValidator } from "@common/json-schema-validator";
import { BaseVO } from "../base.vo";
import { accountIdentity, guestAccountId } from "../../schema";
import { AccountMethods } from "../../const";
import { AccountIdentity, GuestAccountId } from "../../interface";

export class GuestAccountJwtVO extends BaseVO<GuestAccountJwtVORaw> {
  private static validation = JsonSchemaValidator.compile(
    GuestAccountJwtVO.validationSchema()
  );

  constructor(value: GuestAccountJwtVORaw) {
    super(JsonSchemaValidator.assert(GuestAccountJwtVO.validation, value));
  }

  private static validationSchema() {
    return {
      type: "object",
      required: ["id", "identity", "method"],
      properties: {
        id: guestAccountId,
        identity: accountIdentity,
        method: {
          enum: [AccountMethods.Guest]
        }
      }
    };
  }
}

interface GuestAccountJwtVORaw {
  id: GuestAccountId;
  identity: AccountIdentity;
  method: typeof AccountMethods.Guest;
}
